import React from 'react';
import { useLocation } from 'react-router-dom';
import './Logo.css';

function Logo() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <div className='logo-container'>
      <a href='/' className='logo-link'>
        <img src='/pros-logo.png' alt='Logo' className='logo-image' />
        {!isHomePage && (
          <div className='logo-text'>
            <span>air</span>
            <span>TestTool</span>
          </div>
        )}
      </a>
    </div>
  );
}

export default Logo;
